<template lang="pug">
  div
    div(:style="{'height': `${computedWidth + 50}px`}").relative.overflow-hidden.flex.w-full.items-center.justify-center.my-10.sm_my-20
      div.absolute.inset-0
        div.flex.justify-center.items-center.w-full.h-full
          transition(name='fade' appear)
            div
              img(v-if='mainUrl' :src='mainUrl' ).w-64.mx-auto           
              div(v-dompurify-html="globals.statementGlobal").leading-none.text-2xl.sm_text-3xl.md_text-5xl.text-center.font-light.max-w-sm.sm_max-w-lg.px-16 
      staggered-transition(:speed='150')
        rotator-angle(v-for="(entry,index) of computedItems"
          :data-index="index"
          :key='entry.id' 
          :r="computedR" 
          :index='index' 
          :reverse='false' 
          :duration='"60s"'
          :count='itemsAmount' )
          div.w-8.sm_w-16
            router-link(:to="{name:'item', params:{ sectionHandle: entry.sectionHandle, slug:entry.slug}}").pointer-events-auto
              img( :src='entry.url').transform.hover_scale-125.duration-500

    div(v-in-viewport).container.mx-auto.text-acn-green.max-w-md.text-center.px-4
      p(v-dompurify-html="globals.explanationGlobal")
</template>

<script>
import { shuffle, slice } from 'lodash'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Lander',

  data() {
    return {
      wantedItemsAmount: 15,
    }
  },
  computed: {
    ...mapState({
      width: (state) => state.visual.window.width,
      globals: 'globals',
      socials: 'socials',
    }),
    ...mapGetters(['items']),
    itemsAmount() {
      return this.computedItems.length
    },
    computedWidth() {
      return Math.min(800, this.width)
    },
    computedR() {
      return this.computedWidth / 2 - 30
    },
    mainUrl() {
      return this.socials &&
        this.socials.mainIllustration &&
        this.socials.mainIllustration.length
        ? this.socials.mainIllustration[0].url
        : null
    },
    computedItems() {
      return slice(
        shuffle(
          this.items.reduce((items, item) => {
            if (item.image && item.image.length)
              items.push({
                id: item.id,
                url: item.image[0].url,
                sectionHandle: item.sectionHandle,
                slug: item.slug,
              })
            return items
          }, [])
        ),
        0,
        this.wantedItemsAmount
      )
    },
  },
}
</script>

<style lang="stylus" scoped>
.circle
  pointer-events none !important
</style>
